import React from "react";
import { useState, useEffect, useCallback } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { FirmAdminFeatureGrid, FirmAdminRoleGrid } from "./FirmAdminGrids"
import { logout, capitalizeFirstLetter } from "../../utils";
import { NoAccessPopup } from "../../reusable-components/NoAccessPopupComponent/NoAccessModal";
import './FirmAdmin.css'
import * as Icon from "react-bootstrap-icons";
import Modal from "react-bootstrap/Modal";
import Element from '../../reusable-components/InputFields/input';
import { FormContext } from '../../reusable-components/InputFields/FormContext';
import { ToastContainer, toast } from "react-toastify";
import { getFromLS, setToLS } from "../../utils/storage";
import { ThreeCircles } from "react-loader-spinner";
import { groupBy } from "../../utils"
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";
import Dashboard from "../NewDashboard/Dashboard";

const FirmAdmin = () => {
  const featureName = "FRMADMN";
  let token = localStorage.getItem("token");
  const accessibleFeatures = getFromLS('active-features')
  const [userRoleRowData, setUserRoleRowData] = useState([]);
  const [roleFeatureRowData, setRoleFeatureRowData] = useState([]);
  const [allFeatureApiResponse, setAllFeatureApiResponse] = useState();
  const [allFeaturesData, setAllFeaturesData] = useState({})
  const [allRolesData, setAllRolesData] = useState({})
  const [modalState, setModalState] = useState(false)
  const [addUserFormSchema, setAddUserFormSchema] = useState([])
  const [treeNodes, setTreeNodes] = useState([]);
  const [rolesData, setRolesData] = useState([]);

  // Setting page url for helper function
  useEffect(() => {
    setToLS("url", ["firmadmin"])
    localStorage.setItem("defaultActiveKey", "");
  }, [])

  /**
   * Get the form schema for adding user.
   */
  const getAddUserFormschema = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: `/add/user/`,
      show_message: false,
      customized_success_message: "Successful retrieved your data.",
      customized_failure_message: "Unable to fetch details for adding an user, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching details for adding an user, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      setAddUserFormSchema(data.data)
    }
  }

  useEffect(() => {
    console.log("ROLES DATA: ", rolesData)
    const list = Array.isArray(rolesData?.data) ? rolesData.data : [];

    // Active roles → unique by RoleName → { label, value }
    const roleOptions = Array.from(
      new Map(
        list
          .filter(r => r?.Active === 'Y' && r?.RoleName)
          .map(r => {
            const name = String(r.RoleName).trim();
            return [name, { label: name, value: name }]; // <- [key, value]
          })
      ).values()
    );

    // Optional: sort alphabetically (or define your own priority order)
    roleOptions.sort((a, b) => a.label.localeCompare(b.label));

    setAddUserFormSchema(prev =>
      prev.map(f =>
        (f.id === '1.D.6') || (f.label === 'Role' && f.type === 'select')
          ? { ...f, options: roleOptions }
          : f
      )
    );
  }, [rolesData]);


  useEffect(() => {
    console.log("FORM SCHEMA: ", addUserFormSchema)
  }, [addUserFormSchema])



  /**
   * Get all features available for the Firm through active subscription.
   */
  const getAllFeatures = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: `/subscriptions/all_features/`,
      show_message: false,
      customized_success_message: "Successful retrieved all features.",
      customized_failure_message: "Unable to fetch all features, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching all features, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      setAllFeatures(data)
    }
  };

  /**
   * Get roles available for users. This data is used to render active role.
   */

  const getUserRoles = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: `/subscriptions/roles/users/`,
      show_message: false,
      customized_success_message: "Successful retrieved all user roles.",
      customized_failure_message: "Unable to fetch all user roles, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching all user roles, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      setUserRoleData(data)
    }
  }

  /**
   * Get all roles available. This data is used to render select role options.
   */
  const getAllRoles = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: `/subscriptions/roles/`,
      show_message: false,
      customized_success_message: "Successful retrieved all available roles.",
      customized_failure_message: "Unable to fetch all available roles, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching all available roles, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      setAllRoles(data)
      setRolesData(data)
    }
  };

  // Getting the data by calling necessary APIs
  useEffect(() => {
    getAllFeatures()
    getAllRoles()
    getAddUserFormschema()
    localStorage.setItem("defaultActiveKey", "");
  }, [])

  useEffect(() => {
    getUserRoles()
  }, [allRolesData])

  // Render the tree structure for available features for the firm.
  useEffect(() => {
    if (allFeatureApiResponse != undefined) {
      const groupedFeatures = groupBy(allFeatureApiResponse, "FeatureGroup");
      // console.log("GROUPED FEATURES: ", groupedFeatures);
      let nodes = []
      let child1Option = {}
      child1Option["value"] = "Visual"
      child1Option["label"] = "Visual"
      child1Option["id"] = "VisualId"
      child1Option["children"] = []

      let child2Option = {}
      child2Option["value"] = "Conversational"
      child2Option["label"] = "Conversational"
      child2Option["id"] = "ConversationalId"
      child2Option["children"] = []

      let child3Option = {}
      child3Option["value"] = "My flows"
      child3Option["label"] = "My flows"
      child3Option["id"] = "MyFlowsId"
      child3Option["children"] = []

      for (let category in groupedFeatures) {
        let nodeObject = {}
        nodeObject["value"] = capitalizeFirstLetter(category)
        nodeObject["label"] = capitalizeFirstLetter(category)
        nodeObject["children"] = []

        for (let option in groupedFeatures[category]) {
          if (category === "Insights") {
            // console.log("INSIGHTS FEATURES: ", groupedFeatures[category][option])
            if (groupedFeatures[category][option].FeatureSubGroup === "report") {
              let childOption = {}
              childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["id"] = groupedFeatures[category][option].FeatureId
              child1Option["children"].push(childOption)
            } else if (groupedFeatures[category][option].FeatureSubGroup === "insights") {
              let childOption = {}
              childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["id"] = groupedFeatures[category][option].FeatureId
              child2Option["children"].push(childOption)
            }
          } else if (category === "flows") {
            // console.log("FLOWS FEATURES: ", groupedFeatures[category][option])
            if (groupedFeatures[category][option].FeatureSubGroup === "My Flows") {
              let childOption = {}
              childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["id"] = groupedFeatures[category][option].FeatureId
              child3Option["children"].push(childOption)
            } else {
              let childOption = {}
              childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
              childOption["id"] = groupedFeatures[category][option].FeatureId
              nodeObject["children"].push(childOption)
            }
          }
          else {
            let childOption = {}
            childOption["value"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
            childOption["label"] = capitalizeFirstLetter(groupedFeatures[category][option].Name)
            childOption["id"] = groupedFeatures[category][option].FeatureId
            nodeObject["children"].push(childOption)
          }
        }
        if (category === "Insights") {
          nodeObject["children"].push(child1Option)
          nodeObject["children"].push(child2Option)
        } else if (category === "flows") {
          nodeObject["children"].push(child3Option)
        }
        nodes.push(nodeObject)
      }
      setTreeNodes(nodes)
    }
  }, [allFeaturesData]);

  /**
   * Based on all available roles, rendering the row data for grid in required format.
   */
  const setRoleFeatureData = () => {
    const all_roles = getFromLS("all_roles")
    const admin_grid_row_data = []
    // console.log("SET FIRM ROLE FEATURE DATA: ", all_roles)
    for (const role in all_roles) {
      const feature_dict = {}
      const featureList = all_roles[role].FeaturesList
      feature_dict["Role Id"] = all_roles[role].UserRoleId
      feature_dict["Role"] = all_roles[role].RoleName
      feature_dict["Features"] = featureList.map(feature => feature.Name)
      admin_grid_row_data.push(feature_dict)
    }
    // console.log("SET ALL PLAN DATA: ", admin_grid_row_data)
    setRoleFeatureRowData(admin_grid_row_data)
  }

  /**
   * Based on user role, rendering the row data for grid in required format.
   */
  const setUserRoleData = (result) => {
    const admin_grid_row_data = []
    const firm_roles = result.data
    for (const firm in firm_roles) {
      const feature_dict = {}
      feature_dict["Firm Id"] = firm_roles[firm].FirmId
      feature_dict["User Name"] = firm_roles[firm].UserName
      feature_dict["FirstName"] = firm_roles[firm].FirstName
      feature_dict["LastName"] = firm_roles[firm].LastName
      feature_dict["Active"] = firm_roles[firm].Active
      feature_dict["Role"] = firm_roles[firm].Role
      admin_grid_row_data.push(feature_dict)
    }
    setUserRoleRowData(admin_grid_row_data)
    console.log(admin_grid_row_data)
  }

  /**
   * Setting all features in a ID -> Name map.
   * @param {*} result: All feature API response.
   */
  const setAllFeatures = (result) => {
    setAllFeatureApiResponse(result.data)
    const all_features = result.data
    const features_id_name_mapper = {}
    for (let feature in all_features) {
      features_id_name_mapper[all_features[feature].FeatureId] = all_features[feature].Name
    }
    setAllFeaturesData(features_id_name_mapper)
  }

  /**
   * Setting all roles in a ID -> Name map.
   * @param {*} result: All roles API response.
   */
  const setAllRoles = (result) => {
    // console.log("SET ALL ROLES PROPS: ", result)
    const all_roles = result.data
    setToLS("all_roles", all_roles)
    const roles_name_mapper = {}
    for (let feature in all_roles) {
      roles_name_mapper[all_roles[feature].UserRoleId] = all_roles[feature].RoleName
    }
    setAllRolesData(roles_name_mapper)
  }

  /**
   * Grid loader.
   */
  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api
    gridApi.closeToolPanel();
  }, []);

  const AddUserModal = (props) => {
    const formSchema = addUserFormSchema.map(a => Object.assign({}, a));
    const [fullSchema, setFullSchema] = useState([...formSchema])
    const [elements, setElements] = useState(fullSchema);
    const [apiInProgress, setApiInProgress] = useState(false)
    const handleChange = (field_id, event) => {
      const newElements = [...elements]
      newElements.forEach(field => {
        const { type, id } = field;
        if (field_id === id) {
          console.log("TYPE: ", type)
          switch (type) {
            case 'checkbox':
              field['value'] = event.target.checked;
              break;

            case 'select':
              field['value'] = {label: event.label, value: event.value};
              break;

            case 'date':
              field['value'] = event;
              break;

            default:
              field['value'] = event.target.value;
              break;
          }
        }
        const newFullSchema = [...newElements]
        setElements(newFullSchema)
      });
    }

    const handleSubmit = async (event) => {
      setApiInProgress(true)
      event.preventDefault();
      // console.log("ELEMENTS ON RUN WORKFLOW: ", elements)
      let label_id_map = {}
      for (let field_index in elements) {
        Object.assign(label_id_map, { [elements[field_index].label]: parseInt(field_index) })
      }
      const payload =
      {
        "first_name": elements[label_id_map["First Name"]].value,
        "last_name": elements[label_id_map["Last Name"]].value,
        "username": elements[label_id_map["Username (Email)"]].value,
        "password": elements[label_id_map["Password"]].value,
        "email": elements[label_id_map["Username (Email)"]].value,
        "role": (elements[label_id_map["Role"]].value).value
      }

      // console.log("PAYLOAD: ", payload)
      const data = await makeCygnusApiCall({
        type: "POST",
        payload: payload,
        url: `/add/user/`,
        show_message: false,
        customized_success_message: "Successful added user details.",
        customized_failure_message: "Unable to add user details, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while adding user details, please contact support and attach a screenshot.",
        isblob: false
      })
      if (data.success) {
        showModal()
        setElements(formSchema)
      }
      setApiInProgress(false)
    }

    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className={"smallmodal"}
      >
        <Modal.Header closeButton className="modal-header-title">
          {
            <h6>{ }</h6>
          }

        </Modal.Header>
        <Modal.Body>
          <FormContext.Provider value={{ handleChange }}>
            <Form>
              <Row className="no-gutter">
                {
                  elements &&
                  elements.map((field, i) =>
                    <Element
                      key={i}
                      field={field}
                      md={6}
                    />)
                }
              </Row>
            </Form>
          </FormContext.Provider>
        </Modal.Body>
        <Modal.Footer>
          <CustomButton
            progress={apiInProgress}
            onclick={(e) => handleSubmit(e)}
            content={apiInProgress ? "Adding" : "Add"}
            disable={apiInProgress}
          />
        </Modal.Footer>
      </Modal>
    )
  }

  const showModal = () => { setModalState(!modalState) }
  const handleSelect = () => { setRoleFeatureData() }

  // Refresh grid function calls.
  const refreshGrid = () => {
    getAllFeatures()
    getAllRoles()
  }

  // Check for access else return no access modal
  if (!accessibleFeatures.includes(featureName)) {
    return (
      <NoAccessPopup
        featurename={featureName}
      />
    )
  }

  return (
    <>
      {
        localStorage.getItem("defaultActiveKey") === "" ? (
          <>
            <Dashboard />
            <AddUserModal
              show={modalState}
              onHide={() => setModalState(false)}
            />
            <div className="row-wrapper">
              <div className="row-container" id="flexible-width">
                <Row className='no-gutter'>
                  <Col md={12}>
                    <p className="display-6 no-gutter">Firm Admin</p>
                  </Col>
                </Row>
                <Row className='no-gutter'>
                  <Col md={12}>
                    <Tabs
                      defaultActiveKey="manage_user"
                      id="uncontrolled-tab-example"
                      className="mb-3"
                      onSelect={(e) => handleSelect(e)}
                    >
                      <Tab eventKey="manage_user" title="Firm user management" className="tabs">
                        <Row className='no-gutter'>
                          <Col md={12} className="d-flex justify-content-end">
                            <div style={{ marginBottom: "0rem", marginRight: "1.5rem", marginTop: "-4.7rem" }}>
                              <Button
                                className="custom-button add-button"
                                onClick={() => showModal()}
                              >
                                <Icon.Plus /> Add
                              </Button>
                            </div>
                            <div style={{ marginBottom: "0rem", marginTop: "-3.45rem" }}>
                              <Icon.ArrowClockwise
                                onClick={() => refreshGrid()}
                                fill="black"
                                className="reset-button download-excel refresh-button remove-margin"
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12" className="grid-row super-admin super-admin-grid">
                            <FirmAdminRoleGrid
                              rowData={userRoleRowData}
                              rowSelection={'multiple'}
                              rowMultiSelectWithClick={true}
                              sortable={true}
                              filter={true}
                              resizable={true}
                              onGridReady={onGridReady}
                              allRolesData={allRolesData}
                            />
                          </Col>
                        </Row>
                      </Tab>

                      <Tab eventKey="manage_role" title="Role feature access management" className="tabs">
                        <Row>
                          <Col md="12" className="grid-row super-admin super-admin-grid">
                            <FirmAdminFeatureGrid
                              rowData={roleFeatureRowData}
                              rowSelection={'multiple'}
                              rowMultiSelectWithClick={true}
                              sortable={true}
                              filter={true}
                              resizable={true}
                              onGridReady={onGridReady}
                              allFeaturesData={allFeatureApiResponse}
                              checkTreeNodes={treeNodes}
                            />
                          </Col>
                        </Row>
                      </Tab>
                    </Tabs>
                  </Col>
                </Row>
              </div>
            </div>
          </>
        ) : null
      }
    </>
  );
}

export default FirmAdmin;
